<template>
    <v-text-field :value="useDate().toISO8601(date ?? null)" :label="label" readonly hide-details active />
</template>

<script setup lang="ts">
import { useDate } from '@shared/composables/useDate';

defineProps<{
    date: string | null | undefined;
    label: string;
}>();
</script>
